import { useState } from "react";
import { useTranslation } from "react-i18next";
const PharmacyBoxService = (props: any) => {
  const { t } = useTranslation();
  let id = props.id ?? "";
  let title = props.title ?? "";
  let hash = props.hash ?? "";
  const [status, setStatus] = useState(1);
  const toggleClick = () => {
    if (status) {
      setStatus(0);
    } else {
      setStatus(1);
    }
    props.toggleClick(id, status);
  };

  return (
    <div className="row m-0 col-lg-12">
      <div className="col-lg-1 p-1">
        <div
          className={`Marker ${status ? "Active" : ""} top-3`}
          onClick={toggleClick}
        ></div>
      </div>

      <div className="col-lg-10 p-1 mt-1 mb-0">
        <p className="fw-bold ellipsis-title m-0">
          {title}
          <br />
          <small className="fw-normal">{hash}</small>
        </p>
      </div>
    </div>
  );
};

export default PharmacyBoxService;
